export const request = {
  javascript: [
    `var settings = {
  "url": "https://partner.tst.auws.cloud/v2/auth/signup/country",
  "method": "GET",
  "timeout": 0,
  "headers": {
    "X-AU-Key": "XXXX",
    "X-AU-Token": "XXXX"
  },
};

$.ajax(settings).done(function (response) {
  console.log(response);
});`,

    `var settings = {
  "url": "https://partner.tst.auws.cloud/v2/auth/signup/country/US/states",
  "method": "GET",
  "timeout": 0,
  "headers": {
    "X-AU-Key": "XXXX",
    "X-AU-Token": "XXXX"
  },
};

$.ajax(settings).done(function (response) {
  console.log(response);
});`,
  ],

  shell: [
    `wget --no-check-certificate --quiet 
--method GET 
--timeout=0 
--header 'X-AU-Key: XXXX' 
--header 'X-AU-Token: XXXX' 
'https://partner.tst.auws.cloud/v2/auth/signup/country'`,

    `wget --no-check-certificate --quiet 
--method GET 
--timeout=0 
--header 'X-AU-Key: XXXX' 
--header 'X-AU-Token: XXXX' 
'https://partner.tst.auws.cloud/v2/auth/signup/country/US/states'`,
  ],

  ruby: [
    `require "uri"
require "net/http"

url = URI("https://partner.tst.auws.cloud/v2/auth/signup/country")

https = Net::HTTP.new(url.host, url.port)
https.use_ssl = true

request = Net::HTTP::Get.new(url)
request["X-AU-Key"] = "XXXX"
request["X-AU-Token"] = "XXXX"

response = https.request(request)
puts response.read_body`,

    `require "uri"
require "net/http"

url = URI("https://partner.tst.auws.cloud/v2/auth/signup/country/US/states")

https = Net::HTTP.new(url.host, url.port)
https.use_ssl = true

request = Net::HTTP::Get.new(url)
request["X-AU-Key"] = "XXXX"
request["X-AU-Token"] = "XXXX"

response = https.request(request)
puts response.read_body`,
  ],

  python: [
    `import requests

url = "https://partner.tst.auws.cloud/v2/auth/signup/country"

payload={}
headers = {
  'X-AU-Key': 'XXXX',
  'X-AU-Token': 'XXXX'
}

response = requests.request("GET", url, headers=headers, data=payload)

print(response.text)`,

    `import requests

url = "https://partner.tst.auws.cloud/v2/auth/signup/country/US/states"

payload={}
headers = {
  'X-AU-Key': 'XXXX',
  'X-AU-Token': 'XXXX'
}

response = requests.request("GET", url, headers=headers, data=payload)

print(response.text)`,
  ],
};

export const response = {
  success: [
    `{
  "status": "success",
  "data": [
    {
      "iso3": "AND",
      "iso2": "AD",
      "id": "39ab98dd-7784-e811-a95f-0022480186c3",
      "name": "Andorra",
      "isoNumCode": 20
    },
    {
      "iso3": "ARG",
      "iso2": "AR",
      "id": "ffe3000e-7884-e811-a95f-0022480186c3",
      "name": "Argentina",
      "isoNumCode": 32
    },
    {
      "iso3": "ARM",
      "iso2": "AM",
      "id": "2359ff17-7884-e811-a95f-0022480186c3",
      "name": "Armenia",
      "isoNumCode": 51
    },
    {
      "iso3": "ABW",
      "iso2": "AW",
      "id": "9be1e548-7b84-e811-a962-002248073e1b",
      "name": "Aruba",
      "isoNumCode": 533
    },
    {
      "iso3": "AUS",
      "iso2": "AU",
      "id": "9de1e548-7b84-e811-a962-002248073e1b",
      "name": "Australia",
      "isoNumCode": 36
    },
    {
      "iso3": "AUT",
      "iso2": "AT",
      "id": "9fe1e548-7b84-e811-a962-002248073e1b",
      "name": "Austria",
      "isoNumCode": 40
    },
    {
      "iso3": "BHS",
      "iso2": "BS",
      "id": "4c8570d6-4054-e811-a956-0022480149c2",
      "name": "Bahamas",
      "isoNumCode": 44
    },
    {
      "iso3": "BHR",
      "iso2": "BH",
      "id": "a3e1e548-7b84-e811-a962-002248073e1b",
      "name": "Bahrain",
      "isoNumCode": 48
    },
    {
      "iso3": "BGD",
      "iso2": "BD",
      "id": "a5e1e548-7b84-e811-a962-002248073e1b",
      "name": "Bangladesh",
      "isoNumCode": 50
    },
    {
      "iso3": "BRB",
      "iso2": "BB",
      "id": "a7e1e548-7b84-e811-a962-002248073e1b",
      "name": "Barbados",
      "isoNumCode": 52
    },
    {
      "iso3": "BLR",
      "iso2": "BY",
      "id": "a9e1e548-7b84-e811-a962-002248073e1b",
      "name": "Belarus",
      "isoNumCode": 112
    },
    {
      "iso3": "BEL",
      "iso2": "BE",
      "id": "abe1e548-7b84-e811-a962-002248073e1b",
      "name": "Belgium",
      "isoNumCode": 56
    },
    {
      "iso3": "BLZ",
      "iso2": "BZ",
      "id": "ade1e548-7b84-e811-a962-002248073e1b",
      "name": "Belize",
      "isoNumCode": 84
    },
    {
      "iso3": "BMU",
      "iso2": "BM",
      "id": "b1e1e548-7b84-e811-a962-002248073e1b",
      "name": "Bermuda",
      "isoNumCode": 60
    },
    {
      "iso3": "BOL",
      "iso2": "BO",
      "id": "b5e1e548-7b84-e811-a962-002248073e1b",
      "name": "Bolivia",
      "isoNumCode": 68
    },
    {
      "iso3": "BWA",
      "iso2": "BW",
      "id": "b9e1e548-7b84-e811-a962-002248073e1b",
      "name": "Botswana",
      "isoNumCode": 72
    },
  ],
  "error": {},
  "message": "Residence country list fetched successfully."
}`,

    `{
  "status": "success",
  "data": {
    "states": [
      {
        "AL": "Alabama"
      },
      {
        "AK": "Alaska"
      },
      {
        "AZ": "Arizona"
      },
      {
        "AR": "Arkansas"
      },
      {
        "CO": "Colorado"
      },
      {
        "CT": "Connecticut"
      },
      {
        "DE": "Delaware"
      },
      {
        "DC": "District of Columbia"
      },
      {
        "FL": "Florida"
      },
      {
        "GA": "Georgia"
      },
      {
        "ID": "Idaho"
      },
      {
        "IL": "Illinois"
      },
      {
        "IA": "Iowa"
      },
      {
        "KS": "Kansas"
      },
      {
        "KY": "Kentucky"
      },
      {
        "LA": "Louisiana"
      },
      {
        "ME": "Maine"
      },
      {
        "MD": "Maryland"
      },
      {
        "MA": "Massachusetts"
      },
      {
        "MI": "Michigan"
      },
      {
        "MN": "Minnesota"
      },
      {
        "MS": "Mississippi"
      },
      {
        "MO": "Missouri"
      },
      {
        "MT": "Montana"
      },
      {
        "NE": "Nebraska"
      },
      {
        "NV": "Nevada"
      },
      {
        "NH": "New Hampshire"
      },
      {
        "NJ": "New Jersey"
      },
      {
        "NM": "New Mexico"
      },
      {
        "ND": "North Dakota"
      },
      {
        "MP": "Northern Mariana Islands"
      },
      {
        "OK": "Oklahoma"
      },
      {
        "OR": "Oregon"
      },
      {
        "RI": "Rhode Island"
      },
      {
        "SC": "South Carolina"
      },
      {
        "SD": "South Dakota"
      },
      {
        "TN": "Tennessee"
      },
      {
        "TX": "Texas"
      },
      {
        "UT": "Utah"
      },
      {
        "VT": "Vermont"
      },
      {
        "VA": "Virginia"
      },
      {
        "VI": "Virgin Islands"
      },
      {
        "WA": "Washington"
      },
      {
        "WV": "West Virginia"
      },
      {
        "WI": "Wisconsin"
      },
      {
        "WY": "Wyoming"
      }
    ]
  },
  "error": {},
  "message": "state list fetched successfully."
}`,
  ],
};
